const handleSortClick = (sortRef, desc, column) => {
  sortRef.map((element, idx) => {
    if (idx !== column) {
      sortRef[idx].setState({ desc: false, sort: false });
    }
    return null;
  });

  let order = { name: sortRef[column].props.nameSort, desc };

  return order;
};

export default handleSortClick;
